import { Component } from '@angular/core';

/**
 * Root component of the `profile` module (Task 21) — the sidebar identity
 * block's "View my Member Hub profile" link (`RaSurfaceComponent.OpenModule('profile',
 * 'me')`) lands here. Thin wrapper: `RaPersonProfileComponent` (`Standalone`)
 * does the actual work of loading `researchMyProfile` and rendering the page,
 * same split `JobFinderPageComponent`/`GrantFinderPageComponent` use around
 * their own `*DetailComponent`. No `Back` handler is wired — this is a
 * top-level page (module `HiddenFromNav: true`, reached only from the
 * identity block), not a sub-view of another module, so there is nowhere for
 * a Back link to return to.
 */
@Component({
    standalone: false,
    selector: 'ra-my-profile',
    templateUrl: './my-profile-page.component.html',
    // data-accent turns this module's colour (blue — `my-profile.html` sets
    // `.main { --accent:#125b8c }`) into the --accent cascade the profile's
    // Back control and links read. ra-fullwidth drops the centred 1200px
    // reading column: the mockup screen sets no max-width of any kind, and its
    // `.pgrid` right rail is a hard 300px however wide the surface gets
    // (parity/my-profile.md §2-§3). Same opt-in the finder pages take.
    host: {
        'data-accent': 'blue',
        class: 'ra-fullwidth',
    },
})
export class MyProfilePageComponent {}
